<div class="verify-email-container">
  <div class="verify-email-wrapper">
    <!-- Right Section -->
    <div class="verify-email-right">
      <div class="form-content-wrapper">
        <!-- Brand -->
        <div class="marca">
          <img src="assets/layout/images/branding/gainkode-simbolo.svg" [alt]="'brand.name' | transloco" />
          <span>{{ 'layout.pulso.brand' | transloco }}</span>
        </div>

        <!-- Pending State -->
        @if (status === 'pending') {
          <div class="status-container pending">
            <div class="status-icon">
              <lucide-icon name="Mail" [size]="26"></lucide-icon>
            </div>
            <h1 class="status-title">{{ 'auth.verifyEmail.pending.title' | transloco }}</h1>
            <p class="status-message">{{ 'auth.verifyEmail.pending.message' | transloco }}</p>
            @if (email) {
              <p class="email-sent-to">{{ email }}</p>
            }

            <div class="actions">
              @if (email) {
                <app-button
                  [label]="resendDisabled
                    ? ('auth.verifyEmail.resendIn' | transloco: { seconds: resendCountdown })
                    : ('auth.verifyEmail.resend' | transloco)"
                  (onClick)="resendEmail()"
                  [disabled]="resendDisabled"
                  variant="secondary"
                  class="action-button"
                ></app-button>
              }
              <app-button
                [label]="'auth.verifyEmail.backToLogin' | transloco"
                (onClick)="navigateToLogin()"
                variant="link"
                class="back-link"
              ></app-button>
            </div>
          </div>
        }

        <!-- Verifying State -->
        @if (status === 'verifying') {
          <div class="status-container verifying">
            <div class="status-icon spinner">
              <lucide-icon name="LoaderCircle" [size]="26"></lucide-icon>
            </div>
            <h1 class="status-title">{{ 'auth.verifyEmail.verifying.title' | transloco }}</h1>
            <p class="status-message">{{ 'auth.verifyEmail.verifying.message' | transloco }}</p>
          </div>
        }

        <!-- Success State -->
        @if (status === 'success') {
          <div class="status-container success">
            <div class="status-icon success-icon">
              <lucide-icon name="CircleCheck" [size]="26"></lucide-icon>
            </div>
            <h1 class="status-title">{{ 'auth.verifyEmail.success.title' | transloco }}</h1>
            <p class="status-message">{{ 'auth.verifyEmail.success.message' | transloco }}</p>

            <div class="actions">
              <app-button
                [label]="'auth.verifyEmail.success.button' | transloco"
                (onClick)="navigateToLogin()"
                class="action-button"
              ></app-button>
            </div>
          </div>
        }

        <!-- Error State -->
        @if (status === 'error') {
          <div class="status-container error">
            <div class="status-icon error-icon">
              <lucide-icon name="CircleX" [size]="26"></lucide-icon>
            </div>
            <h1 class="status-title">{{ 'auth.verifyEmail.error.title' | transloco }}</h1>
            <p class="status-message">{{ errorMessage || ('auth.verifyEmail.error.message' | transloco) }}</p>

            <div class="actions">
              @if (email) {
                <app-button
                  [label]="resendDisabled
                    ? ('auth.verifyEmail.resendIn' | transloco: { seconds: resendCountdown })
                    : ('auth.verifyEmail.resend' | transloco)"
                  (onClick)="resendEmail()"
                  [disabled]="resendDisabled"
                  variant="secondary"
                  class="action-button"
                ></app-button>
              }
              <app-button
                [label]="'auth.verifyEmail.backToLogin' | transloco"
                (onClick)="navigateToLogin()"
                variant="link"
                class="back-link"
              ></app-button>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Brand panel (desktop and tablet) -->
    <aside class="panel" aria-hidden="true">
      <div class="panel__marca">
        <img src="assets/layout/images/branding/gainkode-logo-negativo.svg" alt="" />
        <span>{{ 'layout.pulso.brand' | transloco }}</span>
      </div>
      <p class="panel__titular">{{ 'auth.panel.headline' | transloco }}</p>
    </aside>
  </div>
</div>
